import React from 'react'
import PropTypes from 'prop-types'
import _map from 'lodash/map'
import SummaryDiamond from '../summary-diamond'
import HorizontalRule from '../horizontal-rule'
import Spacer from '../spacer'

const SummaryDiamondList = props => {
  return (
    <div>
      {
        _map(props.diamonds, (diamond, key) => <SummaryDiamond key={`diamond${key}`} price={props.prices[key]} diamond={diamond.data} />)
          .reduce((acc, element, index) => (acc ? [...acc, <div key={`hr${index}`}><HorizontalRule /><Spacer xs /></div>, element] : [element]), null)
      }
    </div>
  )
}

SummaryDiamondList.propTypes = {
  diamonds: PropTypes.object.isRequired,
  prices: PropTypes.object.isRequired
}

export default SummaryDiamondList



// WEBPACK FOOTER //
// ./src/components/summary-diamond-list/index.js